import createClient from '../../apolloClient';
import MUTATION_CHANGE_EMAIL from '../../mutation/changeEmail';

const handleChangeEmail = async (variables) => {
  const client = createClient();
  const result = await client.mutate({
    mutation: MUTATION_CHANGE_EMAIL,
    variables,
  });
  const { changeEmail } = result?.data || {};
  return changeEmail;
};

export default handleChangeEmail;
